import { produce } from "immer";
import {
  VIEW_FOLDER,
  VIEW_FOLDER_FAILURE,
  VIEW_FOLDER_SUCCESS,
  UPDATE_VIEW_FOLDERS,
  UPDATE_VIEW_FILES,
  VIEW_VERSION,
  VIEW_VERSION_SUCCESS,
  VIEW_VERSION_FAILURE,
  COPY_LINK,
  COPY_LINK_SUCCESS,
  COPY_LINK_FAILURE,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
  ACKNOWLEDGE_POLICY,
  ACKNOWLEDGE_POLICY_SUCCESS,
  ACKNOWLEDGE_POLICY_FAILURE,
  FETCH_POLICY_ACKNOWLEDGEMENT_REPORT,
  FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_SUCCESS,
  FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingViewContent: false,
  viewFolders: [],
  viewFiles: [],
  viewFolderPath: null,
  fileVersionHistory: [],
  isFetchingVersion: false,
  versionHistory: [],
  isCopyingLink: false,
  isDownloading: false,
  isAcknowledgingPolicy: false,
  acknowledgingPolicyItem: null,
  viewFolderName: "",
  isFetchingPolicyAcknowledgementReport: false,
  policyAcknowledgementReport: {
    acknowledgement_count: 0,
    target_count: null,
    acknowledgement_percentage: null,
    target_breakdown: null,
    acknowledgement_details: [],
  },
};

const FolderContentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case VIEW_FOLDER:
        draft.isFetchingViewContent = true;
        break;
      case VIEW_FOLDER_SUCCESS:
        draft.isFetchingViewContent = false;
        draft.viewFolders = action?.payload?.folders ?? [];
        draft.viewFiles = action?.payload?.files ?? [];
        draft.viewFolderPath = action.payload?.path ?? null;
        draft.viewFolderName = action.payload?.name ?? null;
        break;
      case VIEW_FOLDER_FAILURE:
        draft.isFetchingViewContent = false;
        break;
      case UPDATE_VIEW_FOLDERS:
        draft.viewFolders = action.payload;
        break;
      case UPDATE_VIEW_FILES:
        draft.viewFiles = action.payload;
        break;
      case VIEW_VERSION:
        draft.isFetchingVersion = true;
        draft.versionHistory = [];
        break;
      case VIEW_VERSION_SUCCESS:
        draft.isFetchingVersion = false;
        draft.versionHistory = action.payload;
        break;
      case VIEW_VERSION_FAILURE:
        draft.isFetchingVersion = false;
        draft.versionHistory = [];
        break;
      case COPY_LINK:
        draft.isCopyingLink = true;
        break;
      case COPY_LINK_SUCCESS:
        draft.isCopyingLink = false;
        break;
      case COPY_LINK_FAILURE:
        draft.isCopyingLink = false;
        break;
      case DOWNLOAD_FILE:
        draft.isDownloading = true;
        break;
      case DOWNLOAD_FILE_SUCCESS:
        draft.isDownloading = false;
        break;
      case DOWNLOAD_FILE_FAILURE:
        draft.isDownloading = false;
        break;
      case ACKNOWLEDGE_POLICY:
        draft.isAcknowledgingPolicy = true;
        draft.acknowledgingPolicyItem = action.payload ?? null;
        break;
      case ACKNOWLEDGE_POLICY_SUCCESS:
        draft.isAcknowledgingPolicy = false;
        draft.acknowledgingPolicyItem = null;
        break;
      case ACKNOWLEDGE_POLICY_FAILURE:
        draft.isAcknowledgingPolicy = false;
        draft.acknowledgingPolicyItem = null;
        break;
      case FETCH_POLICY_ACKNOWLEDGEMENT_REPORT:
        draft.isFetchingPolicyAcknowledgementReport = true;
        draft.policyAcknowledgementReport = {
          acknowledgement_count: 0,
          target_count: null,
          acknowledgement_percentage: null,
          target_breakdown: null,
          acknowledgement_details: [],
        };
        break;
      case FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_SUCCESS:
        draft.isFetchingPolicyAcknowledgementReport = false;
        draft.policyAcknowledgementReport = {
          acknowledgement_count: action?.payload?.acknowledgement_count ?? 0,
          target_count: action?.payload?.target_count ?? null,
          acknowledgement_percentage:
            action?.payload?.acknowledgement_percentage ?? null,
          target_breakdown: action?.payload?.target_breakdown ?? null,
          acknowledgement_details:
            action?.payload?.acknowledgement_details ?? [],
        };
        break;
      case FETCH_POLICY_ACKNOWLEDGEMENT_REPORT_FAILURE:
        draft.isFetchingPolicyAcknowledgementReport = false;
        draft.policyAcknowledgementReport = {
          acknowledgement_count: 0,
          target_count: null,
          acknowledgement_percentage: null,
          target_breakdown: null,
          acknowledgement_details: [],
        };
        break;

      default:
        return state;
    }
  });

export default FolderContentReducer;
